<template>
  <v-container fluid>
    <h3>공지사항</h3>
    <board-list
      :boardList="boardList"
      :total="total"
      @searchPosts="searchPosts"
      @createPost="createPost"
    />


    <v-dialog
        v-model="isShowBoard"
        max-width="1100"
    >
      <board-notice
          :selected-board="selectedRow"
          @hideDialog="hideDialog"
      />
    </v-dialog>

  </v-container>
</template>

<script>
import BoardList from '@/components/Board/BoardList.vue';
import BoardNotice from '@/components/Board/BoardNotice.vue';
import { mapGetters } from "vuex";
import apiBoard from "@/api/modules/api-board";

export default {
  name: 'InfoNotice',
  components: {
    BoardList,
    BoardNotice
  },
  data() {
    return {
      isShowBoard: false,
      selectedRow: {},

      boardList: [],
      total: 1
    }
  },
  computed: {
    ...mapGetters(['app', 'user']),
  },
  methods:{
    searchPosts(){
      this.searchQuery.page = this.page - 1

      return apiBoard.getBoardPage(this.searchQuery)
          .then(res => {
            this.boardList = res.content
            this.total = res.totalPages
          })
          .finally(() => this.listLoading = false)

    },
    createPost(){
      this.isShowBoard = true
      this.selectedRow = []
    },
    selectPost(post){
      this.isShowBoard = true
      this.selectedRow = post
    },
    hideDialog(){
      this.isShowBoard=true
      this.selectedRow = []
    },
  }
};
</script>
